(() => {
  const dialog = document.getElementById('cozy-delivery-coverage');
  if (!dialog) return;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-cozy-coverage-open]');
    if (opener) { if (!dialog.open) dialog.showModal(); return; }
    if (event.target.closest('[data-cozy-coverage-close]')) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
})();